export function shiftFinancialTotals(shift = {}) {
  const ticketReturns = Number(shift.totalReturnsWithTicket || 0);
  const returns = Number(shift.totalRetours ?? ticketReturns + Number(shift.totalReturnsWithoutTicket || 0));
  const cashRefunds = Number(shift.totalCashReturns ?? shift.totalCashReturnsWithoutTicket ?? 0);
  const cardRefunds = Number(shift.totalCardReturns ?? shift.totalCardReturnsWithoutTicket ?? 0);
  const cash = Number(shift.netCashPayments ?? Number(shift.totalCashPayments || 0) - cashRefunds);
  const card = Number(shift.netCardPayments ?? Number(shift.totalCardPayments || 0) - cardRefunds);
  return {
    sales: Number(shift.netSalesAmount ?? Number(shift.totalSalesAmount || 0) - returns),
    payments: Number(shift.netPaymentsAmount ?? cash + card),
    cash, card, cashRefunds, cardRefunds, returns, ticketReturns,
    noTicketReturns: returns - ticketReturns,
  };
}
